// FocusContext.tsx
import { MutableRefObject, createContext, useContext, useRef } from 'react';

type FocusContextType = {
  inputRef: MutableRefObject<HTMLTextAreaElement | null>;
  focusInput: () => void;
};

const FocusContext = createContext<FocusContextType>({
  inputRef: { current: null },
  focusInput: () => {}
});

export function FocusProvider({ children }: { children: React.ReactNode }) {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const focusInput = () => {
    inputRef.current?.focus();
  };

  return (
    <FocusContext.Provider value={{ inputRef, focusInput }}>
      {children}
    </FocusContext.Provider>
  );
}

export const useFocus = () => useContext(FocusContext);
